<template>
  <v-card>
    <v-card-title>
      Parent Tips
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="openAddDialog">
        Add Tip
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="tips"
        :loading="loading"
        item-key="id"
        class="elevation-1"
      >
        <template v-slot:item.created_at="{ item }">
          {{ formatDate(item.created_at) }}
        </template>
        <template v-slot:item.updated_at="{ item }">
          {{ formatDate(item.updated_at) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="openEditDialog(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Add/Edit Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          {{ isEditing ? 'Edit Tip' : 'Add Tip' }}
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="tipForm.content"
            label="Content"
            required
            :rules="[v => !!v || 'Content is required']"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Cancel</v-btn>
          <v-btn color="primary" @click="saveTip" :loading="saving">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ParentTipsService from '@/services/ParentTipsService'

export default {
  data() {
    return {
      tips: [],
      loading: false,
      dialog: false,
      isEditing: false,
      saving: false,
      tipForm: {
        content: ''
      },
      editingTip: null,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Content', value: 'content' },
        { text: 'Created At', value: 'created_at' },
        { text: 'Updated At', value: 'updated_at' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  mounted() {
    this.fetchTips()
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '-'
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }
      return new Date(dateString).toLocaleString('en-US', options)
    },
    fetchTips() {
      this.loading = true
      ParentTipsService.getTips()
        .then(response => {
          this.tips = response.data.data 
        })
        .catch(error => {
          console.error('Error fetching tips:', error)
          this.$notify({ title: 'Error', text: 'Failed to load tips', type: 'error' })
        })
        .finally(() => {
          this.loading = false
        })
    },
    openAddDialog() {
      this.isEditing = false
      this.tipForm.content = ''
      this.dialog = true
    },
    openEditDialog(item) {
      this.isEditing = true
      this.editingTip = item
      this.tipForm.content = item.content
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.tipForm.content = ''
      this.editingTip = null
    },
    saveTip() {
      if (!this.tipForm.content.trim()) {
        this.$notify({ title: 'Error', text: 'Content is required', type: 'error' })
        return
      }
      this.saving = true
      const data = { content: this.tipForm.content }

      const promise = this.isEditing
        ? ParentTipsService.updateTip(this.editingTip.id, data)
        : ParentTipsService.createTip(data)

      promise
        .then(response => {
          this.$notify({ title: 'Success', text: this.isEditing ? 'Tip updated successfully' : 'Tip added successfully', type: 'success' })
          this.closeDialog()
          this.fetchTips()
        })
        .catch(error => {
          console.error('Error saving tip:', error)
          this.$notify({ title: 'Error', text: 'Failed to save tip', type: 'error' })
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>